import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from '../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import ChatBubble from '@cloudscape-design/chat-components/chat-bubble';
import { Alert, Box, Button, Checkbox, Container, FileInput, FileTokenGroup, Form, FormField, Input, Link, Modal, PromptInput, Select, SpaceBetween, StatusIndicator, Table, Textarea, Token, TruncatedText } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiArrowCollapseUp, mdiCircle, mdiLock, mdiLockOpenVariantOutline, mdiMagnify } from '@mdi/js';
import { Icon } from '@mdi/react';
import DPModal from '../../../../components/DPModal';
import BadgeCustom from '../../../../components/extras/BadgeCustom';
import Favorites from '../../../../components/extras/Favorites';
import UserAvatar from '../../../../components/extras/UserAvatar';
import HorizontalRule from '../../../../components/HorizontalRule';
import SelectUser from '../../../../components/selects/selectUser';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { btnIconForm, OptionDefinition } from '../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, fileToBase64, getCookie, getUrlVersion, getUser, setData, setLoading, setParameters } from '../../../commons/functions';



export const EDVAnnotationsPage = () => {
  const { menu, idUser, parameters, data } = useGlobalState();
  const designationOptions = [
    {
      label: "Aeronautico",
      options: [
        { label: "Leve", value: "2" },
        { label: "Grave", value: "3" },
        { label: "Muy grave", value: "4" }
      ]
    },
    {
      label: "Otros",
      options: [
        { label: "No aeronautico", value: "1" }
      ]
    }
  ];
  const findSelectedOption = (value?: number) => {
    for (const group of designationOptions) {
      const found = group.options.find(opt => opt.value === value?.toString());
      if (found) return found;
    }
    return null;
  };

  const [value, setValue] = React.useState("");
  const [files, setFiles] = React.useState<File[]>([]);

  useGlobalState();
  const { navigate } = useRouter();



  const [incidents, setIncidents] = useState<any[]>([]);
  const [incident, setIncident] = useState<any>(null);
  const [incidentLog, setIncidentLog] = useState<any>(null);
  const [idIncident, setIdIncident] = useState<number>(0);
  const [showIncident, setShowIncident] = useState<boolean>(false);

  const [years, setYears] = useState<OptionDefinition[]>([]);


  const mountedRef = useRef(false);
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");

      if (id && parseInt(id) > 0) {
        setIdIncident(parseInt(id));
        handleGetIncident(parseInt(id));
      } else {

        if (mountedRef.current) {
          mountedRef.current = true;
          handleGetIncidents();
          setIncident(null);
          setIncidentLog(null);
          setIdIncident(0);
        }
      }
      if (!mountedRef.current)
        mountedRef.current = true;
    };

    window.addEventListener("hashchange", handleHashChange);
    // also trigger once on mount
    handleHashChange();

    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);
  const handleGetIncidentsYears = async () => {
    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/edv/annotations/years',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      addNotificationStatus(data, setData);
      if (dataWeb.code == 0) {
        setYears([
          { value: "", label: "Seleccione" },
          ...dataWeb.years.map((item: any) => ({
            value: item.value,
            label: item.label
          }))
        ]);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }
  const updatedIncidents = incidents.map((i: any) => {
    return {
      ...i,
      instructor: getUser(i.idInstructor, data)?.displayName || "Unknown",
      user: getUser(i.idUser, data)?.displayName || "Unknown",
    };
  });
  const handleAddLog = async () => {
    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/edv/annotations/addlog',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify(incidentLog),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      addNotificationStatus(dataWeb, setData);
      if (dataWeb.code == 0) {
        setIncident(dataWeb.annotation);
        setIncidentLog(undefined)
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }
  const handleGetIncident = async (idIncident: number) => {
    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/edv/annotations/get',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify({
          idIncident: idIncident,
          logs: true
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      addNotificationStatus(data, setData);
      if (dataWeb.code == 0) {
        setIdIncident(dataWeb.annotation.idIncident);
        setIncident(dataWeb.annotation)
        if (dataWeb.annotation.dateClosedIncident == "") {

          setIncidentLog({ idIncident: dataWeb.annotation.idIncident, idIncidentLog: 0, incidentLog: "", incidentLogsFiles: [], close: false });
        }
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }
  const handleIncidentOpen = async () => {
    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/edv/annotations/open',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify({
          ...incident,
          year: parameters.year,
          orderBy: "dateIncident",
          order: "DESC"
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      addNotificationStatus(data, setData);
      if (dataWeb.code == 0) {
        setShowIncident(false); setIncident(undefined);
        setIncidents(dataWeb.annotations || []);
        addNotification(data.status, "success", setData);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }
  const handleGetIncidents = async () => {
    try {
      if (!parameters.year) return;
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/edv/annotations/list',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify({
          year: parameters.year,
          orderBy: "dateIncident",
          order: "DESC",
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      addNotificationStatus(data, setData);
      if (dataWeb.code == 0) {

        setIncidents(dataWeb.annotations || []);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }

  useEffect(() => {
    //handleGetIncidents();
    handleGetIncidentsYears();
  }, []);
  useEffect(() => {
    //handleGetIncidents();
    //if (parameters.year)
    //handleGetIncidents();
  }, [parameters.year]);


  const handleFileChange = async (files: File[]) => {
    try {
      // Use Promise.all to concurrently convert all files to Base64
      const base64Results = await Promise.all(files.map(fileToBase64));
      // Map the results back to an array of objects that include the Base64 data
      const attachmentsWithBase64 = base64Results.map(result => ({
        incidentLog: incidentLog.incidentLog,
        incidentLogFileName: result.file.name,
        fileName: result.file.name,
        name: result.file.name,
        type: "",
        fileContent: result.base64,
        fileSize: result.file.size,
        close: incidentLog.close,
      }));


      setIncidentLog((prev: any | undefined) => {
        if (!prev) return prev;
        return {
          ...prev,
          // Use the spread operator on the entire new array to append all new files
          incidentLogsFiles: [...(prev?.incidentLogsFiles || []), ...attachmentsWithBase64],
          close: false
        };
      });
    } catch (error) {
      console.error('Error reading files:', error);
      // Handle error state if necessary
    }
  };
  const incidentNewNalid = incident && incident.dateIncident && incident.idUser && incident.designation && incident.incident && incident.description && incident.idUser !== idUser;

  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          <Header variant="h1" actions={<SpaceBetween direction="horizontal" size="s">
            {incident && (
              <Button variant="link" onClick={() => {
                setIncident(undefined);
                window.location.hash = `#edv/annotations`;
                //window.location.hash = `#edv/annotations?id=0`;
              }}>Volver</Button>
            )}
            <Favorites /></SpaceBetween>}>

            {incident && idIncident > 0 && (
              incident.incident ?? ""
            )}
            {!incident && (
              <>Libro de anotaciones</>
            )}
          </Header>
          {idIncident === 0 && (
            <Table
              filter={
                <Box>
                  <Box float="left">
                    <SpaceBetween direction="horizontal" size="xs">
                      <FormField label="Filtro anual">
                        <Select
                          loadingText="Cargando años..."
                          options={years}
                          selectedOption={years.find(y => y.value.toString() === parameters.year.toString()) || null}
                          onChange={({ detail }) => {
                            setParameters({
                              ...parameters,
                              year: Number(detail.selectedOption.value)
                            });
                          }}
                        />
                      </FormField>

                      <FormField label="&nbsp;">
                        <Button style={{ root: btnIconForm }}
                          disabled={parameters.year === "" || parameters.course === ""}
                          onClick={() => handleGetIncidents()}><Icon path={mdiMagnify} size={1} /></Button>
                      </FormField>
                    </SpaceBetween>
                  </Box>
                  <Box float="right">

                    {!incident && (
                      <FormField label="&nbsp;">
                        <Button variant="normal" onClick={() => {
                          setIncident({ idIncident: 0, idUser: 0, dateIncident: "", designation: 0, incident: "", description: "" });
                          setIdIncident(0);
                          setShowIncident(true);
                          //window.location.hash = `#edv/annotations?id=0`;
                        }}>Nuevo incidente</Button>
                      </FormField>
                    )}
                  </Box>
                </Box>
              }
              stickyHeader
              variant='embedded'
              wrapLines
              columnDefinitions={[
                {
                  id: 'level',
                  header: '',
                  cell: (item) => <Icon path={mdiCircle} size={1}
                    color={item.designation === "1" ? "green" : item.designation === "2" ? "blue" : item.designation === "3" ? "orange" : "red"} />,
                  width: 50,
                },
                {
                  id: 'date',
                  header: 'ID/Fecha',
                  width: 120,
                  cell: (item) => <FormField label={<Link onClick={() => window.location.hash = `#edv/annotations?id=${item.idIncident}`}>{item.idIncident}</Link>}>{item?.dateIncident || ""}</FormField>,
                  minWidth: 100,
                },
                {
                  id: 'user',
                  header: 'Piloto/Instructor',
                  cell: (item) => <FormField label={<TruncatedText>{item.user}</TruncatedText>}>
                    <TruncatedText>{item.instructor}</TruncatedText>
                  </FormField>,
                  maxWidth: 200,
                },
                {
                  id: 'incident',
                  header: 'Incidente',
                  cell: (item) => item.incident,
                },
                {
                  id: 'status',
                  header: '',
                  cell: (item) => item.dateClosedIncident !== "" ? <Icon path={mdiLock} size={1} /> : <Icon path={mdiLockOpenVariantOutline} color={"grey"} size={1} />,
                  width: 50,
                  minWidth: 50,
                },
              ]} items={updatedIncidents}
              empty={
                <Box>Sin incidentes registrados</Box>
              }
            />
          )}
          {incident && idIncident > 0 && (
            <Form>
              <SpaceBetween size="xs" direction='vertical'>
                <Container footer=
                  {
                    <SpaceBetween size="xs" direction='horizontal'>
                      <Box>Clasificación de incidente</Box>

                      {incident?.designation && (
                        <BadgeCustom color={
                          incident.designation === "1" ? "green" : incident.designation === "2" ? "blue" : incident.designation === "3" ? "orange" : "red"
                        }>
                          {incident.designation === "1" ? "No aeronautico" : incident.designation === "2" ? "Leve" : incident.designation === "3" ? "Grave" : "Muy grave"}
                        </BadgeCustom>
                      )}
                    </SpaceBetween>
                  }>
                  <FormField label="Fechas">
                    <SpaceBetween size="xs" direction='horizontal'>
                      <FormField label="Incidente">
                        {incident?.dateIncident || ""}
                      </FormField>
                      <FormField label="Ingreso">
                        {incident?.dateSubmited || ""}
                      </FormField>
                      <FormField label="Cierre">
                        {incident?.dateClosedIncident === "" ? "Incidente abierto" : incident?.dateClosedIncident}
                      </FormField>
                    </SpaceBetween>
                  </FormField>
                  <HorizontalRule />
                  <SpaceBetween size="xs" direction='horizontal'>
                    <div style={{ minWidth: "300" }}>
                      <FormField label="Socio">

                        <UserAvatar idUser={incident?.idUser || 0} width={50} />
                        {getUser(incident?.idUser || 0, data)?.displayName || `Usuario #${incident?.idUser || 0}`}
                      </FormField>
                    </div>
                    <div style={{ minWidth: "300" }}>
                      <FormField label="Instructor">
                        <UserAvatar idUser={incident?.idInstructor || 0} width={50} />
                        {getUser(incident?.idInstructor || 0, data)?.displayName || `Usuario #${incident?.idInstructor || 0}`}
                      </FormField>
                    </div>
                  </SpaceBetween>
                </Container>
                <FormField label={incident?.incident || "Sin título"}>
                  {incident?.description || ""}
                </FormField>
                <HorizontalRule />
                {incident && incident.incidentLogs && (
                  incident.incidentLogs.map((log: any, index: number) => (
                    <ChatBubble
                      key={`log-${index}`}
                      type="outgoing" ariaLabel=''
                      avatar={
                        <UserAvatar idUser={log.idInstructor || 0} width={50} />
                      }
                    >
                      <FormField constraintText={log.dateSubmitedLog || ""}>
                        {log.incidentLog || ""}
                      </FormField>
                      <SpaceBetween size="xs" direction='horizontal'>
                        {log.files && log.files.length > 0 && (
                          log.files.map((file: any) => (
                            <Link variant="secondary" onClick={() => window.open(file.url)}> <Token label={file.name || "Sin nombre"} /></Link>
                          ))
                        )}
                      </SpaceBetween>
                    </ChatBubble>
                  ))
                )}
                {incidentLog && incident.dateClosedIncident === "" && (
                  <SpaceBetween size="xs" direction='vertical'>
                    <PromptInput
                      onAction={(detail) => {
                        if (detail.detail.value.trim() === "") return;
                        handleAddLog()

                      }}
                      disableActionButton={incidentLog.incidentLog.trim() === ""}
                      onChange={({ detail }) =>
                        setIncidentLog({
                          ...incidentLog,
                          incidentLog: detail.value
                        })
                      }
                      value={incidentLog.incidentLog || ""}
                      actionButtonAriaLabel="Enviar observación"
                      actionButtonIconName="send"
                      disableSecondaryActionsPaddings
                      placeholder="Escribe una observación"
                      secondaryActions={
                        <Box padding={{ left: "xxs", top: "xs" }}>
                          <FileInput
                            variant="icon"
                            multiple={true}
                            accept='.jpeg,.jpg,.cup,.doc,.docx,.xls,.xlsx,.pdf,.ppt,.pptx,.zip,.rar,.igc,.kmz'
                            value={files}
                            onChange={({ detail }) =>
                              handleFileChange(detail.value)
                            }
                          >Cargar archivo</FileInput>
                        </Box>
                      }
                      minRows={3}
                      secondaryContent={
                        <SpaceBetween size="xs" direction='vertical'>

                          {incidentLog && incidentLog.incidentLogsFiles.length === 0 && (
                            <StatusIndicator type="info">Haga click en <Icon path={mdiArrowCollapseUp} size={0.65} /> para cargar archivos</StatusIndicator>
                          )}
                          {incidentLog && incidentLog.incidentLogsFiles.length > 0 && (
                            <FileTokenGroup
                              items={incidentLog.incidentLogsFiles.map((file: any) => ({ file }))}
                              onDismiss={({ detail }) => {
                                setIncidentLog({
                                  ...incidentLog,
                                  incidentLogsFiles: incidentLog.incidentLogsFiles.filter((_: any, index: number) => index !== detail.fileIndex)
                                })

                                /*setFiles(files =>
                                  files.filter(
                                    (_, index) =>
                                      index !== detail.fileIndex
                                  )
                                )*/
                              }}
                              alignment="horizontal"
                              showFileSize={false}
                              showFileLastModified={false}
                              showFileThumbnail={false}
                              i18nStrings={{
                                removeFileAriaLabel: () =>
                                  "Remove file",
                                limitShowFewer: "Show fewer files",
                                limitShowMore: "Show more files",
                                errorIconAriaLabel: "Error",
                                warningIconAriaLabel: "Warning"
                              }}
                            />
                          )}
                        </SpaceBetween>

                      }
                    />
                    {incident && incident.idInstructor === idUser && (
                      <FormField constraintText="Incidente no podrá ser modificado y será archivado"
                        label={incidentLog && incidentLog.incidentLogsFiles.length > 0 ? <StatusIndicator type="error">Nota no puede ser finalizada con archivos adjuntos</StatusIndicator> : null}
                      >
                        <Checkbox
                          disabled={incidentLog && incidentLog.incidentLogsFiles.length > 0}

                          onChange={(event) => {
                            setIncidentLog({
                              ...incidentLog,
                              close: event.detail.checked
                            })
                          }}
                          checked={incidentLog.close}
                        >
                          Finalizar Incidente agregando nota como conclusión final
                        </Checkbox>
                      </FormField>
                    )}
                  </SpaceBetween>
                )}
                {incident && incident.dateClosedIncident !== "" && (

                  <ChatBubble
                    key={`log-${"finally"}`}
                    ariaLabel="John Doe at 5:29:02pm"
                    type="outgoing"
                    avatar={
                      <UserAvatar idUser={incident.idInstructor || 0} width={50} />
                    }
                  >
                    <Alert type="info" header="Conclusión y resolución del incidente">
                      <FormField constraintText={incident.dateClosedIncident || ""}>
                        {incident.conclusion || ""}
                      </FormField>

                    </Alert>
                  </ChatBubble>

                )}
              </SpaceBetween>
            </Form>
          )
          }
          <Modal size="large" visible={showIncident} onDismiss={() => { setIncident(undefined); setShowIncident(false) }} header={`Ingreso de incidente`}
            footer={<Box>
              <Box float='left'>
                <Button variant="link" onClick={() => {
                  setShowIncident(false)
                  setIncident(undefined);
                }}>Cancelar</Button>
              </Box>
              <Box float='right'>
                <Button variant="primary"
                  disabled={!incidentNewNalid}
                  onClick={() => {
                    handleIncidentOpen()
                  }}>Crear</Button></Box>

            </Box>}>
            <Form>
              <SpaceBetween size="l" direction='vertical'>
                <SpaceBetween size="l" direction='horizontal'>
                  <FormField label="Fecha del incidente">
                    <DPModal
                      end={new Date()}
                      date={incident?.dateIncident || ""}
                      today
                      onConfirm={(date) => {
                        setIncident({
                          ...incident, dateIncident: date
                        })
                      }} />
                  </FormField>
                  <FormField label="Socio" errorText={incident?.idUser === idUser ? "Usuario involucrado no puede ser igual al instructor" : ""}>
                    <SelectUser value={incident?.idUser || 0} onConfirm={(user) => {

                      if (user)
                        setIncident({ ...incident, idUser: user.idUser });
                    }} />
                  </FormField>
                  <div style={{ width: "200" }}>
                    <FormField label="Clasificación"><Select
                      selectedOption={findSelectedOption(incident?.designation)}
                      onChange={({ detail }) => {
                        setIncident((prev: any) => ({
                          ...prev,
                          designation: Number(detail.selectedOption.value)   // saves the shifgvalue (1–4)
                        }));
                      }}
                      options={designationOptions}
                    />
                    </FormField>
                  </div>
                </SpaceBetween>
                <Alert type='warning' header='Guía de incidente' dismissible={false}>
                  El <strong>título del incidente</strong> no es mas que texto que permite identificar el incidente dentro de un listado mayor. La descripción del incidente, detalla la situación actual que ocurrio. Posterior a la apertura del incidente, cada instructor por separado podrá ir "adjuntando" nuevos antecentes al incidente asi como también archivos adjuntos. Cabe destacar que solo el instructor que realiza la apertura del incidente tiene la posibilidad de <strong>cerrar el incidente</strong> agregando una nueva nota y marcando la casilla de verificación del cierre del incidente. Esta última nota queda como <strong>conclusión y resolución final</strong>.</Alert>
                <FormField label="Título del incidente" stretch>
                  <Input autoComplete="off"
                    value={incident?.incident || ""}
                    onChange={(event) => {
                      setIncident({ ...incident, incident: event.detail.value });
                    }}
                  />
                </FormField>
                <FormField label="Descripción del incidente" stretch>
                  <Textarea value={incident?.description || ""} onChange={(event) => {
                    setIncident({ ...incident, description: event.detail.value });
                  }} placeholder="Descripción detallada del incidente" rows={8} />
                </FormField>
              </SpaceBetween>
            </Form>

          </Modal>
        </SpaceBetween >
      }
    />
  );
};
